import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../context/LanguageContext';
import styles from './PolicyPage.module.css';
import Navbar from '../components/Navbar';

const TermsAndPolicies = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.page}>
      {/* Navbar */}
      <Navbar commonNavigation className={styles.navbar} innerClassName={styles.navInner} brandClassName={styles.navBrand} brand="ReplyShoot">
          <div className={styles.navLinks}>
            <Link to="/" className={styles.navLink}>{t('home', 'Home')}</Link>
            <Link to="/tools" className={styles.navLink}>{t('tools', 'Tools')}</Link>
            <LanguageToggle />
            <Link to="/onboarding" className={styles.navBtn}>{t('getStarted', 'Get Started')}</Link>
          </div>
      </Navbar>

      {/* Hero */}
      <header className={styles.hero}>
        <h1 className={styles.heroTitle}>{t('termsAndPolicies', 'Terms and Policies')}</h1>
        <p className={styles.heroSub}>
          {t('termsSub', 'The terms of service and software licensing conditions for utilizing our cloud software platform.')}
        </p>
      </header>

      {/* Content */}
      <main className={styles.content}>
        <article>
          <p>{t('termsP1', 'These Terms and Policies describe the conditions under which you may access and license ReplyShoot’s cloud software platform, including automated review monitoring, AI-generated response suggestions, and subscription access.')}</p>

          <h2>{t('acceptanceTitle', 'Acceptance')}</h2>
          <p>{t('acceptanceDesc', 'By accessing or using ReplyShoot, you agree to these Terms, our Privacy Policy, and any additional policies published on our website.')}</p>

          <h2>{t('eligibilityTitle', 'Eligibility')}</h2>
          <p>{t('eligibilityDesc', 'Use of our services is limited to individuals and businesses capable of entering into binding agreements. You represent that you are at least 18 years old and authorized to accept these Terms on behalf of the entity you represent.')}</p>

          <h2>{t('serviceDescTitle', 'Service Description')}</h2>
          <p>{t('serviceDescContent', 'ReplyShoot is a self-service Software-as-a-Service (SaaS) cloud application. We provide automated software tools to connect Google Business profiles, monitor incoming customer reviews, generate AI-powered response suggestions, and automate approval workflows via API. ReplyShoot provides software tools only and is not an advertising agency, marketing consultancy, public relations firm, reputation management agency, or search engine optimization service. We do not write manual replies, run marketing campaigns, or guarantee commercial rankings.')}</p>

          <h2>{t('userRespTitle', 'User Responsibilities')}</h2>
          <ul>
            <li>{t('userResp1', 'Provide accurate business information during registration and audit requests.')}</li>
            <li>{t('userResp2', 'Use the service lawfully and respect intellectual property rights.')}</li>
            <li>{t('userResp3', 'Review and approve any AI-generated content before publishing or posting.')}</li>
            <li>{t('userResp4', 'Protect your account credentials and report unauthorized access immediately.')}</li>
          </ul>

          <h2>{t('billingFeesTitle', 'Billing and Fees')}</h2>
          <p>{t('billingFeesDesc', 'Subscription fees grant a non-exclusive license to access our cloud software platform and monthly AI processing quotas. Subscriptions are billed on a recurring monthly or annual basis until cancelled.')}</p>

          <h2>{t('ipTitle', 'Intellectual Property')}</h2>
          <p>{t('ipDesc', 'All ReplyShoot content, software, designs, and trademarks are owned by ReplyShoot or our licensors. You may not reproduce, distribute, or create derivative works without express permission.')}</p>

          <h2>{t('thirdPartyTitle', 'Third-Party Services')}</h2>
          <p>{t('thirdPartyDesc', 'ReplyShoot may integrate with third-party platforms, including review sites, analytics providers, and payment gateways. Use of those services is subject to their own terms and privacy policies.')}</p>

          <h2>{t('disclaimerTitle', 'Disclaimer and Liability')}</h2>
          <p>{t('disclaimerDesc', 'ReplyShoot provides services "as is" without warranties of merchantability or fitness for a particular purpose. We are not liable for indirect, incidental, or consequential damages arising from your use of our platform.')}</p>

          <h2>{t('terminationTitle', 'Termination')}</h2>
          <p>{t('terminationDesc', 'We may suspend or terminate your access for violations of these Terms, nonpayment, or misuse of the platform. You may cancel your subscription at any time in accordance with our cancellation and refund policies.')}</p>

          <h2>{t('termsChangesTitle', 'Changes')}</h2>
          <p>{t('termsChangesDesc', 'We may modify these Terms and Policies at any time. Material changes will be posted on our site and may be communicated by email. Continued use of ReplyShoot after updates constitutes acceptance.')}</p>
        </article>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsAndPolicies;
